import Model from "../../Model.js";

/**
 * `abstractFormulaNode` is an abstract class
 * representing a formula node.
 *
 * It exposes a Visitor Pattern `accept` function
 * to allow concrete implementations of `abstractFormulaVisitor`
 * to traverse the whole tree forming a formula.
 */
export default class AbstractFormulaNode extends Model {
	isKeyFigureDataNode() {
		return this.constructor.isKeyFigureDataNode();
	}

	/**
	 * Accept function of a Visitor Pattern.
	 * Used to dispatch the behavior based on the
	 * node type.
	 *
	 * @param {Visitor} visitor - A visitor
	 * @return {*}
	 */
	accept(visitor) {
		return visitor.visitAbstractNode(this);
	}

	/**
	 * Returns a number this indicates the precedence of the
	 * operation represented by the node.
	 * It is used to introduce parenthesis when needed.
	 *
	 * @return {number}
	 */
	precedence() {
		return this.constructor.precedence();
	}

	/**
	 * Equivalent of `Array.prototype.forEach` (without the second `index`
	 * callback parameter).
	 *
	 * @param {function} fn - function to apply
	 */
	forEach(fn) {
		fn(this);
	}

	/**
	 * Returns true is the node is
	 * a formula leaf.
	 *
	 * @return {boolean}
	 */
	isLeaf() {
		return false;
	}

	getValueType() {
		return "Count";
	}

	resolveReferences() {}

	expandFormula() {
		return this;
	}

	hasReferenceTo(_item) {
		return false;
	}

	isKeyFigureFormulaNode() {
		return false;
	}

	isAdditionFormulaNode() {
		return false;
	}

	removeLastNode() {
		return this;
	}

	removeLastNodeFromSum(node) {
		return new node.constructor({
			operands: node
				.getOperands()
				.slice(0, -1)
				.concat(this.removeLastNode()),
		});
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.type = this.constructor.getType();

		return properties;
	}

	static precedence() {
		return Number.POSITIVE_INFINITY;
	}

	static additiveNodesPrecedence() {
		return 1;
	}

	static multiplicativeNodesPrecedence() {
		return 2;
	}

	static getType() {
		return null;
	}

	static isKeyFigureDataNode() {
		return false;
	}
}
